export const Status = {
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELED: 'canceled'
} as const

export type DocumentStatus = typeof Status[keyof typeof Status]

export const CategoryType = {
  BUSINESS_BANK_STATEMENT: 'bankStatement',
  PERSONAL_BANK_STATEMENT: 'personalBankStatement',
  BUSINESS_TAX_RETURN: 'businessTaxReturns',
  BUSINESS_TAX_RETURN_EXTENSION: 'businessTaxReturnExtension',
  PERSONAL_TAX_RETURN: 'personalTaxReturns',
  PERSONAL_TAX_RETURN_EXTENSION: 'personalTaxReturnExtension',
} as const

export type DocumentCategoryType = typeof CategoryType[keyof typeof CategoryType]

export const VerificationType = {
  IDENTIFICATION: 'identification',
  BELONGING: 'belonging',
  INTEGRITY: 'integrity',
} as const

export type DocumentVerificationType = typeof VerificationType[keyof typeof VerificationType]

export interface FailureDetails {
  verificationType: DocumentVerificationType | null
  message: string | null
  evaluatedType: DocumentCategoryType | null
}

export interface DocumentVerification {
  documentId: number
  categoryType: DocumentCategoryType
  status: DocumentStatus
  passed: boolean | null
  failureDetails?: FailureDetails | null
}

export interface DocumentVerificationEvent {
  documentId: number
  categoryType: DocumentCategoryType
  status: DocumentStatus
  passed: boolean | null
  verificationType: DocumentVerificationType | null
  message: string | null
  evaluatedType: DocumentCategoryType | null
}

export interface DocumentVerificationsResponse {
  data: DocumentVerification[]
}

export interface DocumentIntelligenceConfig {
  verificationsEnabled: boolean
}

export interface DocumentIntelligenceConfigResponse {
  data: DocumentIntelligenceConfig
}

export const LogLevel = {
  INFO: 'info',
  ERROR: 'error',
  WARNING: 'warning',
} as const

export type LogLevelType = typeof LogLevel[keyof typeof LogLevel]
